import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { TrendingUp, Building2, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AdvisoryPage() {
  const pillars = [{
    title: 'Investment & Growth',
    description: 'Strategic capital allocation to scale proven concepts and incubate innovative culinary ventures.',
    icon: <TrendingUp size={40} strokeWidth={1} className="text-brand-gold" data-id="element-285" />,
    link: '/advisory/investment'
  }, {
    title: 'Real Estate',
    description: 'Acquisition and development of prime hospitality real estate to secure long-term operational stability.',
    icon: <Building2 size={40} strokeWidth={1} className="text-brand-gold" data-id="element-286" />,
    link: '/advisory/real-estate'
  }, {
    title: 'Management Company',
    description: 'Comprehensive operational oversight, standardizing excellence across all portfolio properties.',
    icon: <Briefcase size={40} strokeWidth={1} className="text-brand-gold" data-id="element-287" />,
    link: '/advisory/management'
  }];
  return <div className="bg-brand-dark" data-id="element-288">
      <PageHero title="Advisory & Investment" subtitle="Leveraging over a decade of operational excellence to build sustainable value in the hospitality sector." backgroundImage="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80" data-id="element-289" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-290">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-291"></div>
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(#D3AE6E 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} data-id="element-292"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-293">
          <div className="text-center mb-24" data-id="element-294">
            <motion.h2 className="text-4xl md:text-5xl font-serif text-white mb-6" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-295">
              Our Approach
            </motion.h2>
            <motion.div className="w-16 h-1 bg-brand-gold mx-auto mb-10" initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} data-id="element-296" />
            <motion.p className="text-lg md:text-xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-297">
              JJ Group's advisory arm operates at the intersection of culinary
              passion and rigorous financial discipline. We partner with
              visionary chefs, developers, and investors to create, scale, and
              manage profitable hospitality assets.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-298">
            {pillars.map((pillar, index) => <motion.div key={index} className="bg-white/5 border border-white/10 p-10 backdrop-blur-sm hover:bg-white/10 transition-colors group" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-299">
                <div className="mb-8 bg-brand-dark/50 w-16 h-16 rounded-full flex items-center justify-center border border-brand-gold/20 group-hover:scale-110 transition-transform duration-500" data-id="element-300">
                  {pillar.icon}
                </div>
                <h3 className="text-2xl font-serif text-white mb-4" data-id="element-301">
                  {pillar.title}
                </h3>
                <p className="text-white/60 font-light leading-relaxed mb-8 min-h-[80px]" data-id="element-302">
                  {pillar.description}
                </p>
                <Link to={pillar.link} className="inline-flex items-center text-brand-gold text-sm uppercase tracking-[0.2em] hover:text-white transition-colors" data-id="element-303">
                  Explore{' '}
                  <span className="ml-2 transform group-hover:translate-x-2 transition-transform" data-id="element-304">
                    →
                  </span>
                </Link>
              </motion.div>)}
          </div>

          <motion.div className="mt-32 text-center" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-305">
            <h3 className="text-2xl font-serif text-white mb-8" data-id="element-306">
              Ready to collaborate?
            </h3>
            <div className="flex flex-col md:flex-row justify-center gap-6" data-id="element-307">
              <Link to="/advisory/investment" className="bg-brand-gold text-brand-dark px-8 py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-white transition-colors" data-id="element-308">
                Partner With Us
              </Link>
              <Link to="/advisory/management" className="border border-brand-gold text-brand-gold px-8 py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-brand-gold hover:text-brand-dark transition-colors" data-id="element-309">
                Request Management Proposal
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}